import type { ReactNode } from 'react'
import { InterviewsSection } from '@/components/dashboard/interviews/interviews-section'
import { AdminInterviewsProvider } from './admin-interviews-provider'

export function InterviewsEmbed({ clientId }: { clientId: string }): ReactNode {
  return (
    <div className="rounded-xl border border-(--cd-border) bg-(--cd-card) p-4">
      <p className="mb-4 text-sm text-(--cd-text-muted)">
        Two-way synced with the client's Job Tracker — anything you add or edit
        here shows up on their dashboard immediately.
      </p>
      <AdminInterviewsProvider clientId={clientId}>
        <InterviewsSection />
      </AdminInterviewsProvider>
    </div>
  )
}
